import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import styled from 'styled-components';
import { setOnlineStatus } from './actions';
import { setCurrentUser } from '../Login/actions';
import { getCatalogueLabel, getOrdersLabel, getPartnersNavLabel } from '../../utils/shopTypes';

const ShopStatus = styled.a`
  margin-top: 1em;
  color: #000 !important;
  text-decoration: none;
`;

const CurrentShop = styled.a`
  color: #000 !important;
`;

class Nav extends Component {
  state = {
    mobileClassName: 'navbar-menu',
    mobileNavCollapsed: false,
  }

  logout = () => {
    this.props.history.push('/login');
    this.toggleNav(this.state.mobileNavCollapsed);
    this.props.clearUser();
  }

  toggleNav = (value) => {
    if (value) {
      this.setState({ mobileClassName: 'navbar-menu', mobileNavCollapsed: false });
    } else {
      this.setState({ mobileClassName: 'navbar-menu is-active', mobileNavCollapsed: true });
    }
  }

  render() {
    const { shop, setAvailability, history, user, dashboard } = this.props;
    const shopTypeId = dashboard && dashboard.shopTypeId;
    const catalogueLabel = getCatalogueLabel(shopTypeId);

    return (
      <nav className='navbar is-fixed-top' role='navigation' aria-label='main navigation'>
        <div className='container'>
          <div className='navbar-brand'>
            <span className='navbar-item'>
              <h3 className='title is-4 pointer logo' onClick={() => history.push('/')}>
                cloudchefs
              </h3>
            </span>
            {shop && (
              <ShopStatus
                role='button'
                className='navbar-item is-hidden-desktop tag is-grey'
                aria-label='menu'
                aria-expanded='false'
                data-target='navbar'
              >
                {shop.name}
              </ShopStatus>
            )}
          </div>
          <div id='navbar' className={this.state.mobileClassName}>
            <div className='navbar-end'>
              <CurrentShop className='navbar-item' to='/'>
                {shop && <span className='tag is-grey'>{shop.name}</span>}
              </CurrentShop>
              <Link className='navbar-item' to='/'>Dashboard</Link>
              <Link className='navbar-item' to='/menu'>{catalogueLabel}</Link>
              <Link className='navbar-item' to='/orders'>{getOrdersLabel(shopTypeId)}</Link>
              <Link className='navbar-item' to='/partners'>{getPartnersNavLabel(shopTypeId)}</Link>
              <Link className='navbar-item' to='/ratings'>Ratings</Link>
              <Link className='navbar-item' to='/wait-time'>Wait time</Link>
              <Link className='navbar-item' to='/settings/update'>Settings</Link>
              <Link className='navbar-item' to='/service-availability/update'>Availability</Link>
              <Link className='navbar-item' to='/guide'>
                <span className='icon-text'>
                  <span className='icon'><span className='fas fa-question-circle' /></span>
                  <span>Guide</span>
                </span>
              </Link>
              {dashboard && (
                <div className='navbar-item'>
                  {dashboard.isOnline
                    ? <button onClick={() => setAvailability(shop.id, false, user.idToken)} className='button is-primary'>
                        Close shop
                      </button>
                    : <button onClick={() => setAvailability(shop.id, true, user.idToken)} className='button is-success'>
                        Open shop
                      </button>}
                </div>
              )}
              <div className='navbar-item'>
                <button onClick={this.logout} className='button is-light'>Sign Out</button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  shop: state.app.shop,
  user: state.auth.user,
  dashboard: state.dashboard,
});

const mapDispatchToProps = dispatch => ({
  clearUser: () => dispatch(setCurrentUser(null)),
  setAvailability: (shopId, value, idToken) => dispatch(setOnlineStatus(shopId, value, idToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
